import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrganisationService } from '../organisation.service';
import { map, take } from 'rxjs/operators';
import { Organisation } from '../organisation.types';
import { UserService } from 'app/core/user/user.service';

export const organisationOnBoardedGuard: CanActivateFn = (route, state) => {
    const _organisationService = inject(OrganisationService);
    const _router = inject(Router);
    const _userService = inject(UserService);

    
    // return true only if the organisation is onboarded
    // else redirect to onboarding page
    return _organisationService.currentOrganisation$.pipe(
        take(1),
        map((organisation: Organisation) => {
            if (!organisation.onboarded) {
                return _router.createUrlTree(['/' + organisation.slug + '/onboard']);
            }
            return true;
        })
    );
}; 